export default {
  instagram: 'Instagram',
  instagramcomments: 'Instagram Comments',
  facebook: 'Facebook',
  facebookinbox: 'Facebook Inbox',
  facebookgroups: 'Facebook Groups',
  facebookcomments: 'Facebook Comments',
  youtube: 'YouTube',
  youtubecomments: 'YouTube Comments',
  twitter: 'Twitter',
  twitterinbox: 'Twitter Inbox',
  tumblr: 'Tumblr',
  news: 'Portals',
  blogs: 'Blogs',
  foruns: 'Forums',
  comentariosemartigos: 'Article Comments',
  googleplay: 'Google Play',
  googleplus: 'Google Plus',
  googlemybusiness: 'Google My Business',
  foursquare: 'Foursquare',
  buscape: 'Product Reviews',
  reclameaqui: 'Reclame Aqui',
  linkedin: 'LinkedIn',
  linkedincomments: 'LinkedIn Comments',
  tv: 'TV',
  radio: 'Radio',
  impressas: 'Print',
  portais: 'Portals',
  tiktok: 'TikTok',
  blip: 'Blip',
  importeddata: 'Imported Data',
  bluesky: 'Bluesky',
  notclassified: 'Not Classified',
};
